import { render, staticRenderFns } from "./FileImageView.vue?vue&type=template&id=3727bdfd&scoped=true&"
import script from "./FileImageView.vue?vue&type=script&lang=ts&"
export * from "./FileImageView.vue?vue&type=script&lang=ts&"
import style0 from "./FileImageView.vue?vue&type=style&index=0&id=3727bdfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3727bdfd",
  null
  
)

export default component.exports